import { render, staticRenderFns } from "./FormRadioInput.vue?vue&type=template&id=735b68f0&"
import script from "./FormRadioInput.vue?vue&type=script&lang=js&"
export * from "./FormRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports